import * as React from 'react';
import './HambugerMenu.scss';
import { mapModifiers } from 'components/_utils';
import HeadingList from 'components/molecules/HeadingList/HeadingList';
import FunctionButton from 'components/atoms/FunctionButton/FunctionButton';
import { history } from '../../../App';

interface Props {
  open?: any;
  openFnc?: any;
}

export const HambugerMenu = (props: Props) => (
  <div
    className={mapModifiers('o-hambuger-menu', props.open ? ['show'] : [''])}
    onClick={() => props.openFnc(!props.open)}
  >
    <div className="o-hambuger-menu__symbol">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <>
      <div className="o-hambuger-menu__menu">
        <div className="o-hambuger-menu__menu__item">
          <FunctionButton modifiers={['mail']} href="https://mail.google.com/" />
	        <HeadingList modifiers={['line']}>
				<a href="https://mail.google.com/" target="_blank" rel="noopener noreferrer">メール</a>
			</HeadingList>
		</div>

        <div className="o-hambuger-menu__menu__item">
          <FunctionButton modifiers={['calendar']} href="https://calendar.google.com/" />
          <HeadingList modifiers={['line']}>
			<a href="https://calendar.google.com/" target="_blank" rel="noopener noreferrer">カレンダー</a>
		  </HeadingList>
        </div>

        {/* aチャンネル */}
        <div className="o-hambuger-menu__menu__item">
		  <FunctionButton modifiers={['video']} href="https://adastria-gc.coorum.jp/menus/gjkpszhrwwytwah2/announcements" />
		  <HeadingList modifiers={['line']}>
		  	<a href="https://adastria-gc.coorum.jp/menus/gjkpszhrwwytwah2/announcements" target="_blank" rel="noopener noreferrer">aチャンネル</a>
          </HeadingList>
		</div>

        <div className="o-hambuger-menu__menu__item">
          <FunctionButton modifiers={['gemini']} href="https://gemini.google.com/app" />
          <HeadingList modifiers={['line']}>
			  <a href="https://gemini.google.com/app" target="_blank" rel="noopener noreferrer">Gemini</a>
		  </HeadingList>
        </div>

        <div className="o-hambuger-menu__menu__item">
          <FunctionButton modifiers={['chabomon']} href="https://sites.google.com/andst-hd.co.jp/andst-hd-toiawase/" />
          <HeadingList modifiers={['line']}>
			<a href="https://sites.google.com/andst-hd.co.jp/andst-hd-toiawase/" target="_blank" rel="noopener noreferrer">チャボモン</a>
		  </HeadingList>
        </div>

        <div className="o-hambuger-menu__menu__item">
          <FunctionButton modifiers={['andai']} href="https://gemini.google.com/gem/1IsUhCqejjrQmUKFPYudaKmV1wGk4uHZ-?usp=sharing" />
          <HeadingList modifiers={['line']}>
			<a href="https://gemini.google.com/gem/1IsUhCqejjrQmUKFPYudaKmV1wGk4uHZ-?usp=sharing" target="_blank" rel="noopener noreferrer">AI活用チャットボット</a>
		  </HeadingList>
        </div>

        <div className="o-hambuger-menu__menu__logout">
          <HeadingList type={'logout'} modifiers={['logout']} onClick={() => { history.push('/logout') }}>
            ログアウト
          </HeadingList>
        </div>
        <div className="o-hambuger-menu__menu__backlayer" onClick={() => props.openFnc(!props.open)}></div>
      </div>
    </>
  </div>
);

export default HambugerMenu;